var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.listData),function(value,key){return _c('div',{key:key},[_c('h3',[_vm._v(_vm._s(key))]),_c('div',{staticClass:"course-grid-view"},_vm._l((value),function(elm,key_){return _c('grid-item',{key:key_,attrs:{"data":elm},on:{"onClick":function($event){return _vm.handleClick(elm)}}})}),1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }